import { IRevision } from './revision.models';

export const getCurrentRevision = (revisions: IRevision[]) => {
  return revisions.find((s) => s.isCurrent);
};

export const isSuperseded = (revisions: IRevision[]) => {
  const currentRevision = getCurrentRevision(revisions);
  return !(currentRevision?.isLatest ?? true);
};
